import PropTypes from 'prop-types'
import React from 'react'
import { withTranslation } from 'react-i18next'

import Action from '../../components/Action'
import ListToolbar from '../../components/ListToolbar'
import Table, { Body, Column, Head, Header, Row } from '../../components/Table'
import SelectedIndicator from '../../components/SelectedIndicator'
import Tile, { Grid, GridItem, LabelledValue } from '../../components/Tile'
import { TextLink } from '../../components/type'

const ValveList = ({
  children,
  valves,
  onSearch,
  onTileClick,
  selectedIds,
  toolbarActions,
  tileActions,
  batchActions,
  t,
}) => {
  const selectionMode = selectedIds != null

  return (
    <ListToolbar onSearch={onSearch} actions={toolbarActions}>
      {({ showTiles }) => {
        return showTiles ? (
          <Grid>
            {(valves || []).map(
              (
                {
                  id,
                  name,
                  currentIsSuspended,
                  sensorBasedIrrigationEnabled,
                  currentValue,
                },
                index
              ) => {
                // 0 = Auto; 1 = Manual; 2 = Demand Driven
                let modeIndex = null
                if (currentIsSuspended) {
                  modeIndex = 1
                } else if (!currentIsSuspended) {
                  if (sensorBasedIrrigationEnabled) {
                    modeIndex = 2
                  } else {
                    modeIndex = 0
                  }
                } else {
                  // fall back to Auto
                  modeIndex = 0
                }

                // only show current value (state) if its value is known
                const showCurrentValue = currentValue == 0 || currentValue == 1

                return (
                  <GridItem key={index}>
                    <Tile
                      onClick={() => onTileClick(id)}
                      title={name}
                      selected={selectionMode && selectedIds.includes(id)}
                      actions={tileActions ? tileActions(id) : undefined}
                    >
                      <LabelledValue
                        value={t(`attributes:valve.modes_short.${modeIndex}`)}
                        label={t('attributes:valve.mode')}
                      />
                      {showCurrentValue && (
                        <LabelledValue
                          value={t(
                            `attributes:valve.states_short.${currentValue}`
                          )}
                          label={t('attributes:valve.state')}
                        />
                      )}
                    </Tile>
                  </GridItem>
                )
              }
            )}
          </Grid>
        ) : (
          <Table spacious divided>
            <Head>
              <Row>
                <Header colSpan={2}>{t('models:valve', { count: 0 })}</Header>
              </Row>
            </Head>
            <Body>
              {(valves || []).map(({ id, name }, index) => {
                return (
                  <Row
                    key={index}
                    selected={selectionMode && selectedIds.includes(id)}
                    onClick={selectionMode ? () => onTileClick(id) : undefined}
                  >
                    <Column>
                      {selectionMode ? (
                        name
                      ) : (
                        <TextLink to={`/valves/${id}`}>{name}</TextLink>
                      )}
                    </Column>
                    {!selectionMode && <Column actions>{children(id)}</Column>}
                    {selectionMode && (
                      <Column actions={1}>
                        {selectedIds.includes(id) && (
                          <SelectedIndicator inline />
                        )}
                      </Column>
                    )}
                  </Row>
                )
              })}
            </Body>
          </Table>
        )
      }}
    </ListToolbar>
  )
}

ValveList.propTypes = {
  valves: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSearch: PropTypes.func.isRequired,
  onTileClick: PropTypes.func.isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  toolbarActions: PropTypes.node,
  tileActions: PropTypes.func,
  children: PropTypes.func.isRequired,
}

export default withTranslation()(ValveList)
